export const tipoExibicaoHistorico = {
  fixo: 'FIXO',
  fixoSistema: 'FIXOSISTEMA',
  naoFixo: 'NAOFIXO',
};
